import {type Iso8601, type StoppageDto, StoppageKind} from '@hconnect/common/types'

/**
 * The stoppage is split and Part2 is created as a new stoppage.
 * The stoppageEnd of the original stoppage(now Part1) is updated to the splitTime by BE.
 * The stoppageStart of the new stoppage is updated to the split time.
 * @param originalStoppage
 * @param updatedStart Stoppage split time
 * @returns Partial<StoppageDto>
 */
export const getStoppageSplitInitialData = (
  originalStoppage: StoppageDto,
  updatedStart: Iso8601
): Partial<StoppageDto> => {
  return {
    eventType: StoppageKind.Incident,
    stoppageType: originalStoppage.stoppageType,
    stoppageStart: updatedStart,
    stoppageEnd: originalStoppage.stoppageEnd,
    originalSplitStoppageId: originalStoppage['id'],
    ...(originalStoppage.mainEquipment && {
      mainEquipment: originalStoppage.mainEquipment
    }),
    ...(originalStoppage.equipment && {
      equipment: originalStoppage.equipment
    }),
    ...(originalStoppage.processStage && {
      processStage: originalStoppage.processStage
    }),
    ...(originalStoppage.upmDepartmentId && {
      upmDepartmentId: originalStoppage.upmDepartmentId
    })
  }
}
